(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[268],{

/***/ 7920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var models_conent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3290);
/* harmony import */ var components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6627);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3641);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5582);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8369);
/* harmony import */ var styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var components_OldDesign_subscribe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1640);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9603);
/* harmony import */ var _components_OldDesign_OldLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4990);
/* harmony import */ var _components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5314);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);

















// Search crawlers execute the page and used to be counted as readers: AdsBot,
// Applebot, Bytespider and bingbot accounted for roughly 900 of the view writes
// observed in production over six weeks.
var BOT_USER_AGENT = /bot|crawler|spider|bytespider|applebot|adsbot/i;

var Blog = function Blog(_ref) {
  var _post$image, _post$image2, _post$issue, _post$issue2, _post$issue3, _post$issue4, _post$categories2, _filteredBlog, _filteredBlog2, _others$contents2, _others$contents2$fil, _others$contents3, _others$contents3$fil;

  var post = _ref.post,
      others = _ref.others;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showNoti = _useState[0],
      setShowNoti = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      view = _useState2[0],
      setView = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      url = _useState3[0],
      setUrl = _useState3[1];

  var _useLocale = (0,_components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_8__/* .useLocale */ .b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var copyLink = function copyLink() {
    var dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = window.location.href;

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      dummy.readOnly = true;
      var range = document.createRange();
      range.selectNodeContents(dummy);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      dummy.setSelectionRange(0, 999999);
      document.execCommand('copy');
      document.body.removeChild(dummy);
    } else {
      navigator.clipboard.writeText(window.location.href);
    }

    setShowNoti(true);
    setTimeout(function () {
      setShowNoti(false);
    }, 2000);
  };

  var filteredBlog = function filteredBlog() {
    var _others$contents;

    return others === null || others === void 0 ? void 0 : (_others$contents = others.contents) === null || _others$contents === void 0 ? void 0 : _others$contents.map(function (content) {
      var _content$categories;

      var res = content === null || content === void 0 ? void 0 : (_content$categories = content.categories) === null || _content$categories === void 0 ? void 0 : _content$categories.map(function (category) {
        var _post$categories;

        return post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.map(function (res) {
          return res.name;
        }).includes(category.name);
      });

      if (res.some(function (obj) {
        return obj;
      }) && content.title !== post.title) {
        return content;
      }
    }).filter(function (obj) {
      return obj !== undefined;
    });
  };

  function truncateString(str) {
    if ((str === null || str === void 0 ? void 0 : str.length) > 85) {
      return str.substring(0, 85) + '...';
    } else {
      return str;
    }
  }

  function calculateRead(item) {
    var _moment$fromNow;

    moment__WEBPACK_IMPORTED_MODULE_4___default().locale(lang);
    return item ? lang === 'th' ? 'อ่านเมื่อ ' + moment__WEBPACK_IMPORTED_MODULE_4___default()(item).fromNow() : ((_moment$fromNow = moment__WEBPACK_IMPORTED_MODULE_4___default()(item).fromNow()) === null || _moment$fromNow === void 0 ? void 0 : _moment$fromNow.toUpperCase()) + ' READ' : null;
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _localStorage$getItem, _post$documentId;

    setLang((_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th');
    setUrl(window.location.href);

    if (BOT_USER_AGENT.test(navigator.userAgent)) {
      var _post$view;

      setView(Number((_post$view = post === null || post === void 0 ? void 0 : post.view) !== null && _post$view !== void 0 ? _post$view : 0));
      return;
    } // documentId, not the numeric id: Strapi 5 recreates the published row
    // on every publish with a fresh id, which would 404 this call.


    axios__WEBPACK_IMPORTED_MODULE_3___default().post("".concat(models_conent__WEBPACK_IMPORTED_MODULE_10__.be, "/api/blogs/").concat((_post$documentId = post.documentId) !== null && _post$documentId !== void 0 ? _post$documentId : post.id, "/view")).then(function (res) {
      var _res$data$view, _res$data;

      setView(Number((_res$data$view = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.view) !== null && _res$data$view !== void 0 ? _res$data$view : 0));
    })["catch"](function () {
      var _post$view2;

      setView(Number((_post$view2 = post === null || post === void 0 ? void 0 : post.view) !== null && _post$view2 !== void 0 ? _post$view2 : 0));
    });
  }, [post]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [showNoti ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "top-32 sm:top-20 right-3 fixed w-1/3 sm:w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md bg-blue-100 border-blue-500 text-blue-900",
      role: "alert",
      "data-aos": "fade-left",
      "data-aos-easing": "linear",
      "data-aos-duration": "300",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "flex",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
          className: "font-bold text-3xl sm:text-lg",
          children: "Copied!"
        })
      })
    }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      content: {
        content: post === null || post === void 0 ? void 0 : post.detailTH,
        title: post === null || post === void 0 ? void 0 : post.title,
        image: models_conent__WEBPACK_IMPORTED_MODULE_10__.be + (post === null || post === void 0 ? void 0 : (_post$image = post.image) === null || _post$image === void 0 ? void 0 : _post$image.url)
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "w-full mt-24 sm:mt-20 md:mt-16 xl:mt-10 bg-cover bg-center bg-no-repeat blog-banner",
      style: {
        backgroundImage: "url(".concat(models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1).concat(post === null || post === void 0 ? void 0 : (_post$image2 = post.image) === null || _post$image2 === void 0 ? void 0 : _post$image2.url, ")")
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "text-left text-dark-blue text-webkit-center lg:px-48",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "w-20 2xl:w-16 fixed",
        style: {
          right: '6.5px',
          top: '30%'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "my-1 text-3xl sm:text-2xl md:text-xl lg:text-lg font-medium text-center",
          children: "Share this"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: "grid space-y-2 w-max mx-auto",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .FacebookShareButton */ .Dk, {
            url: url,
            className: "kiki",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .FacebookIcon */ .Vq, {
              size: 32,
              bgStyle: {
                fill: '#0b273e'
              },
              round: true,
              className: "mr-1 custom-icon"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .TwitterShareButton */ .B, {
            url: url,
            className: "kiki",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .TwitterIcon */ .Zm, {
              size: 32,
              bgStyle: {
                fill: '#0b273e'
              },
              round: true,
              className: "mr-1 custom-icon"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .LineShareButton */ .Ni, {
            url: url,
            className: "kiki",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .LineIcon */ .zb, {
              size: 32,
              bgStyle: {
                fill: '#0b273e'
              },
              round: true,
              className: "mr-1 custom-icon"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .LinkedinShareButton */ .r2, {
            url: url,
            className: "kiki",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_11__/* .LinkedinIcon */ .pA, {
              size: 32,
              bgStyle: {
                fill: '#0b273e'
              },
              round: true,
              className: "mr-1 custom-icon"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("button", {
            className: "bg-transparent border-none p-0 cursor-pointer outline-none",
            onClick: function onClick() {
              return copyLink();
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              src: "/images/link-icon.svg",
              width: "32",
              height: "32",
              className: "custom-icon",
              alt: "copy link",
              loading: "lazy"
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h1", {
        className: "text-5xl text-primary text-center sm:text-4xl w-11/12 lg:w-full mt-24 xl:mt-24 mb-5",
        style: {
          lineHeight: '4rem'
        },
        children: post === null || post === void 0 ? void 0 : post.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "grid grid-cols-3 align-self-center w-5/6 md:w-1/2",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "/issues",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "bg-dark-blue border-dark-blue border-2 2xl:border-4 text-center text-white py-4 md:py-1",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              className: "text-3xl md:text-lg lg:text-xl cursor-pointer",
              children: "Issues"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-span-2 border-dark-blue border-2 2xl:border-4 text-center py-4 md:py-1",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
            className: "text-3xl md:text-lg lg:text-xl",
            children: (post === null || post === void 0 ? void 0 : (_post$issue = post.issue) === null || _post$issue === void 0 ? void 0 : _post$issue.month) || '-'
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: '/issues/' + (post === null || post === void 0 ? void 0 : (_post$issue2 = post.issue) === null || _post$issue2 === void 0 ? void 0 : _post$issue2.id) + '-' + (post === null || post === void 0 ? void 0 : (_post$issue3 = post.issue) === null || _post$issue3 === void 0 ? void 0 : _post$issue3.theme),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "col-span-3 border-dark-blue border-t-0 border-2 2xl:border-4 2xl:border-t-0 text-center py-5 sm:py-3 2xl:py-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              className: "text-5xl md:text-4xl 2xl:text-3xl cursor-pointer",
              children: (post === null || post === void 0 ? void 0 : (_post$issue4 = post.issue) === null || _post$issue4 === void 0 ? void 0 : _post$issue4.theme) || '-'
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "mt-5 text-3xl md:text-xl w-5/6 md:w-3/4 flex justify-center",
        style: {
          lineHeight: '3rem'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: "mr-2",
          children: "Categories:"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "wrap-anywhere text-left w-auto",
          children: post === null || post === void 0 ? void 0 : (_post$categories2 = post.categories) === null || _post$categories2 === void 0 ? void 0 : _post$categories2.map(function (res, i) {
            var _post$categories3;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
              href: '/categories/' + (res === null || res === void 0 ? void 0 : res.id) + '-' + (res === null || res === void 0 ? void 0 : res.name),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                className: "underline cursor-pointer ".concat(i < ((_post$categories3 = post.categories) === null || _post$categories3 === void 0 ? void 0 : _post$categories3.length) ? 'pr-3' : ''),
                children: "#".concat(res.name)
              })
            }, i);
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "mt-2 md:mt-0 text-2xl sm:text-xl md:text-base w-5/6 md:w-1/2 font-light",
        children: ["Inspired by: ", (post === null || post === void 0 ? void 0 : post.inspired) || '-']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "mt-4 text-3xl md:text-xl w-5/6 md:w-1/2",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
          icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faEye */ .Mdf,
          className: "self-center mr-1 fa-sm my-auto"
        }), view, " Views"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("hr", {
        className: "border-dark-blue mt-12 mx-12 sm:mx-44 lg:mx-20",
        style: {
          'borderWidth': '1px'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "px-24 md:px-36 py-12 md:py-16 text-4xl sm:text-3xl md:text-2xl lg:text-lg xl:text-base font-light text-left leading",
        dangerouslySetInnerHTML: {
          __html: post === null || post === void 0 ? void 0 : post.description
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "text-left text-dark-blue mx-12 lg:mx-24 mt-5 mb-32 lg:mb-20",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "text-5xl md:text-4xl font-bold mb-10",
        children: "You may also like"
      }), (_filteredBlog = filteredBlog()) !== null && _filteredBlog !== void 0 && _filteredBlog.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2",
        children: [(_filteredBlog2 = filteredBlog()) === null || _filteredBlog2 === void 0 ? void 0 : _filteredBlog2.map(function (item, index) {
          var _item$imageMobile, _item$image;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
            children: index < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: "".concat(index < 3 ? 'mb-14 lg:mb-12' : '', " md:flex"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: '/blogs/' + item.id + '-' + item.url,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$imageMobile = item.imageMobile) === null || _item$imageMobile === void 0 ? void 0 : _item$imageMobile.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " hidden lg:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  })]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "text-4xl sm:text-3xl md:text-2xl lg:text-lg font-normal leading-snug cursor-pointer",
                    children: truncateString(item.title)
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                  children: [moment__WEBPACK_IMPORTED_MODULE_4___default()(item.created_at).format('MMM DD, YYYY').toUpperCase(), item.timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                    className: "mx-3",
                    children: "\u2022"
                  }) : '', calculateRead(item.timeStamp), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    children: item.categories.map(function (tag, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: '/categories/' + tag.id + '-' + tag.name,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                          children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                            className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2",
                            children: tag.name
                          }, i) : ''
                        })
                      }, i);
                    })
                  })]
                })]
              })]
            }) : ''
          }, index);
        }), filteredBlog().length < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
          children: others === null || others === void 0 ? void 0 : (_others$contents2 = others.contents) === null || _others$contents2 === void 0 ? void 0 : (_others$contents2$fil = _others$contents2.filter(function (item) {
            return item.name === 'article';
          })) === null || _others$contents2$fil === void 0 ? void 0 : _others$contents2$fil.sort(function () {
            return Math.random() - 0.5;
          }).map(function (item, index) {
            var _item$imageMobile2, _item$image2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: index < 4 - filteredBlog().length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "".concat(index < 3 ? 'mb-14 lg:mb-12' : '', " md:flex"),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                      src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$imageMobile2 = item.imageMobile) === null || _item$imageMobile2 === void 0 ? void 0 : _item$imageMobile2.url),
                      loading: "lazy",
                      alt: item.title,
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                      src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url),
                      loading: "lazy",
                      alt: item.title,
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " hidden lg:block h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                    })]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: '/blogs/' + item.id + '-' + item.url,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      className: "text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer",
                      children: truncateString(item.title)
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                    children: [moment__WEBPACK_IMPORTED_MODULE_4___default()(item.created_at).format('MMM DD, YYYY').toUpperCase(), item.timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                      className: "mx-3",
                      children: "\u2022"
                    }) : '', calculateRead(item.timeStamp), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      children: item.categories.map(function (tag, i) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                          href: '/categories/' + tag.id + '-' + tag.name,
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                            children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                              className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2",
                              children: tag.name
                            }, i) : ''
                          })
                        }, i);
                      })
                    })]
                  })]
                })]
              }) : ''
            }, index);
          })
        }) : '']
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2",
        children: others === null || others === void 0 ? void 0 : (_others$contents3 = others.contents) === null || _others$contents3 === void 0 ? void 0 : (_others$contents3$fil = _others$contents3.filter(function (item) {
          return item.name === 'article';
        })) === null || _others$contents3$fil === void 0 ? void 0 : _others$contents3$fil.sort(function () {
          return Math.random() - 0.5;
        }).map(function (item, index) {
          var _item$imageMobile3, _item$image3;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
            children: index < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: "".concat(index < 3 ? 'mb-14 lg:mb-12' : '', " md:flex"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: '/blogs/' + item.id + '-' + item.url,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$imageMobile3 = item.imageMobile) === null || _item$imageMobile3 === void 0 ? void 0 : _item$imageMobile3.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_10__/* .strapi */ .s1 + ((_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_13___default().minW15), " hidden lg:block h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  })]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer",
                    children: truncateString(item.title)
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                  children: [moment__WEBPACK_IMPORTED_MODULE_4___default()(item.created_at).format('MMM DD, YYYY').toUpperCase(), item.timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                    className: "mx-3",
                    children: "\u2022"
                  }) : '', calculateRead(item.timeStamp), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    children: item.categories.map(function (tag, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: '/categories/' + tag.id + '-' + tag.name,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                          children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                            className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2",
                            children: tag.name
                          }, i) : ''
                        })
                      }, i);
                    })
                  })]
                })]
              })]
            }) : ''
          }, index);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "px-12 xl:px-24",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_OldDesign_subscribe__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})]
  });
};

Blog.getLayout = function (page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_OldDesign_OldLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Blog);

/***/ }),

/***/ 4922:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[id]",
      function () {
        return __webpack_require__(7920);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,885,735,859,373,818,60,608,597,774,888,179], function() { return __webpack_exec__(4922); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);